import React from 'react';
import { Link } from 'react-router-dom';

function BrandLogo({ to = '/', onClick, size = 'default' }) {
  const isCompact = size === 'compact';

  return (
    <Link to={to} className="flex items-center gap-3" onClick={onClick}>
      <div className={`flex items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-[#07111a] shadow-[0_12px_30px_rgba(34,211,238,0.18)] ${isCompact ? 'h-10 w-10' : 'h-12 w-12'}`}>
        <img
          src="/logo.svg"
          alt="DailyProfit Trader logo"
          className={`${isCompact ? 'h-9 w-9' : 'h-11 w-11'} object-contain`}
        />
      </div>
      <div>
        <span className={`block bg-gradient-to-r from-emerald-200 via-cyan-200 to-sky-300 bg-clip-text font-black tracking-tight text-transparent ${isCompact ? 'text-lg sm:text-xl' : 'text-2xl'}`}>
          DailyProfit Trader
        </span>
        <span className={`text-slate-400 ${isCompact ? 'hidden text-[11px] uppercase tracking-[0.24em] sm:block' : 'text-xs uppercase tracking-[0.28em]'}`}>
          Automated MT5 Control
        </span>
      </div>
    </Link>
  );
}

export default BrandLogo;